// extracted by mini-css-extract-plugin
module.exports = {"pager":"index-module--pager--2bXsn"};